import {
  Empty,
  Spin,
  Timeline,
  message,
  Button,
  Image,
  Modal,
  Carousel
} from "antd";
import { get, isEmpty, map, size } from "lodash";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import services from "services";

let isOver = false;

const RenderActivity = ({ data }) => {
  const [isPreviewVisible, setIsPreviewVisible] = useState({});
  const [isShowVideo, setIsShowVideo] = useState({});

  return data.map(item => {
    let time = item?.created
      ? dayjs(item.created).format("DD/MM/YYYY HH:mm:ss")
      : "";
    let message = item?.message;
    return (
      <Timeline.Item key={item.id} className="profile-log__item">
        <span>{`${time} : ${message}`}</span>

        {size(item.image_urls) > 0 && (
          <>
            <Button
              type="text"
              onClick={() => setIsPreviewVisible({ [item.id]: true })}
            >
              <span
                className="text-primary"
                style={{ textDecoration: "underline" }}
              >
                Ảnh
              </span>
            </Button>

            <div
              style={{
                display: "none"
              }}
            >
              <Image.PreviewGroup
                preview={{
                  visible: isPreviewVisible[item.id] || false,
                  onVisibleChange: () =>
                    setIsPreviewVisible({ [item.id]: true })
                }}
              >
                {map(item.image_urls, (url, i) => {
                  return (
                    <Image
                      src={url}
                      key={i}
                      style={{ display: i == 0 ? "block" : "none" }}
                    />
                  );
                })}
              </Image.PreviewGroup>
            </div>
          </>
        )}

        {size(item.video_links) > 0 && (
          <>
            <Button
              type="text"
              onClick={() => setIsShowVideo({ [item.id]: true })}
            >
              <span
                className="text-primary"
                style={{ textDecoration: "underline" }}
              >
                Video
              </span>
            </Button>

            <Modal
              width={800}
              title={"Video"}
              centered
              open={isShowVideo[item.id] || false}
              onCancel={() => setIsShowVideo({ [item.id]: false })}
              footer={null}
            >
              <Carousel>
                {map(item.video_links, (url, i) => {
                  return <video src={url} key={i} controls />;
                })}
              </Carousel>
            </Modal>
          </>
        )}
      </Timeline.Item>
    );
  });
};

const ProfileLogPage = ({ dataSource }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [logsData, setLogsData] = useState({
    data: [],
    total: 0
  });
  const [timelineConfig, setTimelineConfig] = useState({
    page: 0,
    size: 20
  });

  const getLogData = async params => {
    setIsFetching(true);
    let res = await services.GdmsService.getProfileLogs(params);
    const isSuccess = get(res, "success");
    let data = [];
    if (isSuccess) {
      data = get(res, "data", []);
      let total = get(res, "total_elements", 0);
      if (total <= data.length) {
        isOver = true;
      }
      setLogsData(prev => {
        return {
          ...prev,
          data,
          total
        };
      });
    } else {
      message.error(get(res, "message", "Có lỗi khi lấy thông tin logs"));
    }
    setIsFetching(false);
  };

  const _handleScroll = async e => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    if (scrollHeight - scrollTop === clientHeight && !isOver) {
      let params = {
        page: timelineConfig.page + 1,
        size: timelineConfig.size,
        device_id: dataSource.device_id || undefined
      };

      let res = await services.GdmsService.getProfileLogs(params);
      const isSuccess = get(res, "success");
      let data = [];
      if (isSuccess) {
        data = get(res, "data", []);
        let total = get(res, "total_elements", 0);
        let joinData = JSON.parse(JSON.stringify([...logsData.data, ...data]));
        if (total <= joinData.length) {
          isOver = true;
        }
        setLogsData(prev => {
          return {
            ...prev,
            data: joinData
          };
        });
      } else {
        message.error(get(res, "message", "Có lỗi khi lấy thông tin logs"));
      }

      setTimelineConfig(prev => {
        return {
          ...prev,
          page: prev.page + 1
        };
      });
    }
  };

  useEffect(
    () => {
      if (dataSource?.device_id) {
        isOver = false;
        let params = {
          page: 0,
          size: 20,
          device_id: dataSource.device_id
        };

        getLogData(params);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dataSource]
  );

  return (
    <Spin spinning={isFetching}>
      <div
        style={{
          height: "350px",
          overflow: "auto"
        }}
        onScroll={_handleScroll}
      >
        {isEmpty(logsData?.data) ? (
          <Empty />
        ) : (
          <Timeline pending={isOver ? false : "Loading..."}>
            <RenderActivity data={logsData?.data || []} />
          </Timeline>
        )}
      </div>
    </Spin>
  );
};

export default React.memo(ProfileLogPage);
